var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 493,
    viewBox: "0 0 493 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.75 260.61C164.218 257.441 165.664 254.507 167.948 252.261C167.982 252.227 168.017 252.194 168.051 252.159C176.434 243.776 174.42 228.168 163.551 217.299C152.682 206.43 137.074 204.415 128.69 212.799C128.653 212.836 128.616 212.874 128.579 212.912C126.337 215.196 123.404 216.639 120.237 217.109C116.676 217.638 113.248 219.288 110.525 222.06C104.021 228.683 104 239.415 110.481 246.061C112.042 247.663 113.838 248.893 115.76 249.753C122.601 252.812 128.045 258.256 131.105 265.097C131.964 267.019 133.194 268.814 134.796 270.376C141.443 276.858 152.178 276.836 158.8 270.329C161.573 267.604 163.223 264.174 163.75 260.61Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.063 192.378C185.849 186.592 186.82 178.182 182.232 173.594C177.644 169.006 169.234 169.977 163.448 175.763C157.662 181.549 156.691 189.959 161.279 194.547C165.867 199.135 174.277 198.164 180.063 192.378Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.914 194.047C141.7 188.261 142.671 179.851 138.082 175.263C133.494 170.675 125.085 171.646 119.299 177.432C113.513 183.217 112.542 191.627 117.13 196.215C121.718 200.804 130.128 199.832 135.914 194.047Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.194 218.514C211.98 212.728 212.951 204.318 208.363 199.73C203.775 195.142 195.365 196.113 189.579 201.899C183.793 207.685 182.822 216.095 187.41 220.683C191.998 225.271 200.408 224.3 206.194 218.514Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.979 262.126C209.764 256.34 210.735 247.93 206.147 243.342C201.559 238.754 193.149 239.725 187.364 245.511C181.578 251.297 180.607 259.707 185.195 264.295C189.783 268.883 198.193 267.912 203.979 262.126Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.4 424.888C222.868 421.719 224.314 418.785 226.598 416.54C226.632 416.506 226.667 416.472 226.701 416.438C235.084 408.054 233.07 392.447 222.201 381.577C211.332 370.708 195.724 368.694 187.34 377.077C187.303 377.115 187.266 377.152 187.229 377.19C184.987 379.475 182.053 380.918 178.887 381.388C175.325 381.916 171.898 383.566 169.175 386.339C162.671 392.961 162.65 403.694 169.131 410.339C170.692 411.941 172.488 413.172 174.41 414.031C181.251 417.09 186.695 422.535 189.754 429.376C190.614 431.297 191.844 433.093 193.446 434.655C200.093 441.136 210.828 441.114 217.45 434.607C220.223 431.882 221.873 428.452 222.4 424.888Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.713 356.656C244.499 350.87 245.47 342.46 240.882 337.872C236.294 333.284 227.884 334.255 222.098 340.041C216.312 345.827 215.341 354.237 219.929 358.825C224.517 363.413 232.927 362.442 238.713 356.656Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.564 358.325C200.349 352.539 201.32 344.129 196.732 339.541C192.144 334.953 183.734 335.924 177.949 341.71C172.163 347.496 171.192 355.906 175.78 360.494C180.368 365.082 188.778 364.111 194.564 358.325Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.844 382.793C270.63 377.007 271.601 368.597 267.013 364.009C262.425 359.421 254.015 360.392 248.229 366.178C242.443 371.964 241.472 380.373 246.06 384.961C250.648 389.55 259.058 388.579 264.844 382.793Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.628 426.404C268.414 420.618 269.385 412.208 264.797 407.62C260.209 403.032 251.799 404.003 246.013 409.789C240.228 415.575 239.257 423.985 243.845 428.573C248.433 433.161 256.843 432.19 262.628 426.404Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.068 143.292C281.536 140.123 282.982 137.189 285.266 134.944C285.3 134.91 285.335 134.876 285.369 134.842C293.752 126.458 291.738 110.85 280.869 99.9813C269.999 89.1121 254.392 87.0976 246.008 95.4813C245.971 95.5186 245.934 95.5562 245.897 95.5939C243.655 97.8784 240.721 99.3216 237.555 99.7915C233.993 100.32 230.566 101.97 227.843 104.742C221.339 111.365 221.318 122.098 227.798 128.743C229.36 130.345 231.156 131.575 233.078 132.435C239.919 135.494 245.363 140.939 248.422 147.78C249.282 149.701 250.512 151.497 252.114 153.058C258.761 159.54 269.496 159.518 276.118 153.011C278.891 150.286 280.541 146.856 281.068 143.292Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.381 75.0601C303.167 69.2742 304.138 60.8644 299.55 56.2762C294.962 51.6881 286.552 52.6592 280.766 58.4451C274.98 64.231 274.009 72.6408 278.597 77.229C283.185 81.8171 291.595 80.846 297.381 75.0601Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.231 76.7288C259.017 70.9429 259.988 62.5331 255.4 57.9449C250.812 53.3568 242.402 54.3279 236.616 60.1138C230.831 65.8997 229.86 74.3095 234.448 78.8977C239.036 83.4858 247.446 82.5147 253.231 76.7288Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.512 101.196C329.298 95.4105 330.269 87.0007 325.681 82.4126C321.093 77.8245 312.683 78.7955 306.897 84.5814C301.111 90.3674 300.14 98.7772 304.728 103.365C309.316 107.953 317.726 106.982 323.512 101.196Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.296 144.808C327.082 139.022 328.053 130.612 323.465 126.024C318.877 121.436 310.467 122.407 304.681 128.193C298.895 133.979 297.924 142.389 302.513 146.977C307.101 151.565 315.511 150.594 321.296 144.808Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.717 307.57C340.186 304.401 341.632 301.467 343.916 299.222C343.95 299.188 343.984 299.154 344.019 299.12C352.402 290.736 350.387 275.129 339.519 264.26C328.649 253.39 313.042 251.376 304.658 259.76C304.621 259.797 304.584 259.834 304.547 259.872C302.305 262.157 299.371 263.6 296.205 264.07C292.643 264.598 289.216 266.249 286.493 269.021C279.989 275.643 279.968 286.376 286.448 293.022C288.01 294.623 289.806 295.854 291.727 296.713C298.568 299.773 304.013 305.217 307.072 312.058C307.932 313.979 309.162 315.775 310.764 317.337C317.411 323.818 328.146 323.796 334.768 317.289C337.541 314.565 339.191 311.134 339.717 307.57Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.031 239.338C361.817 233.552 362.788 225.143 358.2 220.555C353.612 215.966 345.202 216.937 339.416 222.723C333.63 228.509 332.659 236.919 337.247 241.507C341.835 246.095 350.245 245.124 356.031 239.338Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.881 241.007C317.667 235.221 318.638 226.811 314.05 222.223C309.462 217.635 301.052 218.606 295.266 224.392C289.48 230.178 288.509 238.588 293.098 243.176C297.686 247.764 306.095 246.793 311.881 241.007Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.162 265.475C387.948 259.689 388.919 251.279 384.331 246.691C379.742 242.103 371.333 243.074 365.547 248.86C359.761 254.646 358.79 263.056 363.378 267.644C367.966 272.232 376.376 271.261 382.162 265.475Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.946 309.086C385.732 303.3 386.703 294.891 382.115 290.302C377.527 285.714 369.117 286.685 363.331 292.471C357.545 298.257 356.574 306.667 361.162 311.255C365.751 315.843 374.16 314.872 379.946 309.086Z",
    fill: "#88CCDD",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.64,
    height: 105.64,
    fill: "white",
    transform: "translate(105.634 170.138)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.64,
    height: 105.64,
    fill: "white",
    transform: "translate(164.284 334.416)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.64,
    height: 105.64,
    fill: "white",
    transform: "translate(222.952 52.8199)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.64,
    height: 105.64,
    fill: "white",
    transform: "translate(281.602 217.098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoots);
export default __webpack_public_path__ + "static/media/foots.635e7fc06db162aab4bbc72ec5a4a2a8.svg";
export { ForwardRef as ReactComponent };